var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68893 1.54534C9.29829 1.93585 9.29823 2.56911 9.6888 2.95968L10.6731 3.94401C11.0637 4.33458 11.697 4.33453 12.0875 3.94388L12.592 3.43918C12.9824 3.04863 12.9823 2.41557 12.5919 2.02509L11.6077 1.04094C11.2172 0.650465 10.5842 0.650408 10.1936 1.04081L9.68893 1.54534ZM0.971182 10.263C0.838664 10.3955 0.746052 10.5626 0.703905 10.7452L0.228551 12.8048C0.145452 13.1648 0.468141 13.4875 0.828187 13.4044L3.02749 12.8968C3.11878 12.8757 3.20232 12.8294 3.26858 12.7632L9.71396 6.3184C10.1046 5.92784 10.1045 5.29457 9.71389 4.90405L8.72887 3.91931C8.33833 3.52887 7.70524 3.52892 7.31475 3.9194L0.971182 10.263Z",
    fill: "#C6FCA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.447fcd390ffe4779d611612a714e026e.svg";
export { ForwardRef as ReactComponent };